import { useRestaurantContext } from '@app/pages/Restaurant/context';
import { Menu } from '@app/types';
import { ClickAwayListener, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import classes from './styles.module.css';
import cx from 'classnames';
import ArrowDown from '@app/components/Icons/ArrowDown';

type Props = {
  menus: Menu[];
  activedMenu: Menu | null;
  onSelectMenuToScroll: (menu: Menu, menuIndex: number) => void;
};

type StylesP = {
  color: string;
};

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: '#fff',
    fontFamily: 'Montserrat,sans-serif',
  },
  icon: (props: StylesP) => ({
    fill: props.color,
  }),
}));

export default function MenuScrollerSelector({ menus, activedMenu, onSelectMenuToScroll }: Props) {
  const { primaryColor } = useRestaurantContext();

  const [collapsed, setCollapsed] = useState(true);

  function handleOnChangeSelect(index: number) {
    onSelectMenuToScroll(menus[index], index);
    toggleCollapse();
  }

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  function handleClickAway() {
    setCollapsed(true);
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div className={classes.container}>
        <div className={classes.containHeader} onClick={toggleCollapse}>
          <span className={classes.selected}>{activedMenu?.nome ?? ''}</span>
          <div className={cx(classes.iconArrow, !collapsed && classes.iconReverse)}>
            <ArrowDown color={primaryColor} />
          </div>
        </div>

        <div className={cx(classes.collapseSelectbox, collapsed && classes.hiddenCollapseSelectbox)}>
          {menus.map((menu, index) => {
            return (
              <div key={String(index)} className={classes.itemSelect} onClick={() => handleOnChangeSelect(index)}>
                {menu.nome}
              </div>
            );
          })}
        </div>
      </div>
    </ClickAwayListener>
  );
}
